import SnAvailabilityPreviewTable from "./snAvailabilityPreviewTable.container";

export default SnAvailabilityPreviewTable;
